

 //--
import request from "../../../core/wrappers/axios-wrapper";
import { ApiURL } from "../../../types/constants/apiUrls/api-urls";
import { RequestType } from "../../../types/enums/request-enums";
 //#region comment metod

 
 const PostGetOFSInformation = (params: any) =>
 request({
   url: ApiURL.Command.GetOfsInformation,
   method: RequestType.GET, 
   params:params,
  }); 
 
 const PostUpdateOFSInformation = (data: any) =>
 request({
   url: ApiURL.Command.UpdateOfsInformation,
   method: RequestType.POST,
   data,
 });

export interface GetHolidayDatesForCountryRequest {
    countryId: number;
}

export interface CountryHolidayConfigurationDto {
    countryId: number;
    countryCode: string;
    startHour: number;
    endHour: number;
    holidays: number[];
}

export interface GetHolidayDatesForCountryResponse {
    country: CountryHolidayConfigurationDto;
}

export interface SetHolidayDatesForCountriesResponse {
    result: boolean;
    updatedCountryCount: number;
}

const PostGetHolidayDatesForCountry = (params: GetHolidayDatesForCountryRequest) =>
    request({
        url: ApiURL.Command.GetHolidayDatesForCountry,
        method: RequestType.GET,
        params,
    });

export interface SetHolidayDatesForCountriesRequest {
    countries: CountryHolidayConfigurationDto[];
}

const PostSetHolidayDatesForCountries = (data: SetHolidayDatesForCountriesRequest) =>
    request({
        url: ApiURL.Command.SetHolidayDatesForCountries,
        method: RequestType.POST,
        data,
    });

const OFSLogsCommand = {
  PostGetOFSInformation,
  PostUpdateOFSInformation,
  PostGetHolidayDatesForCountry,
  PostSetHolidayDatesForCountries,
};

export default OFSLogsCommand;
